// extracted by mini-css-extract-plugin
export default {"link":"Link_link__j0O+Y","light":"Link_light__naJlS","dark":"Link_dark__ksXfQ"};